import "./GYoutube.scss";
import {
    ArrowRight,
    Code2,
    Globe,
    Laptop,
    Lightbulb,
    Rocket, Sparkles,
    Zap,
} from "lucide-react";
import {useTranslation} from "react-i18next";
import Card from "../../Components/CardGallery/CardGallery";
import {useNavigate} from "react-router-dom";
import {DiscordMember, GalleryItem} from "../../types";
import {discordUrl} from "../../Global";
import {useState} from "react";

const steps = [
    {
        id: "01",
        icon: Lightbulb,
    },
    {
        id: "02",
        icon: Laptop,
    },
    {
        id: "03",
        icon: Code2,
    },
    {
        id: "04",
        icon: Rocket,
    },
];

interface GYoutubeProps {
    staff: DiscordMember[] | [];
    workGraphic: GalleryItem[];
}

export default function GYoutube({ staff, workGraphic }: GYoutubeProps) {
    const { t } = useTranslation();

    const ourThumbnail = workGraphic.filter(item => item.type === "copertina");

    const graphicsYoutube = staff.filter((member) =>
        member.roles.some((role) => role.id === '1558566882762690590')
    );

    const [maxPhoto, setMaxPhoto] = useState<number>(5);

    return (
        <section className="graphics-youtube">
            {/* ===== HERO ===== */}

            <div className="graphics-youtube__hero">
                <div className="graphics-youtube__hero-container">
                    {/* Left */}
                    <div className="graphics-youtube__hero-content">
                        <h1 className="graphics-youtube__title">
                            {t("youtube-thumbnail.title.up")}
                            <br />
                            {t("youtube-thumbnail.title.down")}<span>{t("youtube-thumbnail.title.bold")}</span>
                        </h1>
                        <p className="graphics-youtube__description">
                            {t("youtube-thumbnail.subtitle")}
                        </p>
                        <div className="graphics-youtube__actions">
                            <a href={discordUrl} target="_blank" className="graphics-youtube__button" rel="noreferrer">
                                {t("youtube-thumbnail.preventive")}
                                <ArrowRight size={18} />
                            </a>
                            {ourThumbnail.length > 0 && (
                                <a href="#portfolio" className="graphics-youtube__button graphics-youtube__button--secondary">
                                    {t("youtube-thumbnail.lookWorks")}
                                </a>
                            )}
                        </div>
                    </div>

                    {/*Presentation*/}
                </div>
            </div>

            {/* ===== STEP ===== */}
            <div className="graphics-youtube__steps">
                <div className="graphics-youtube__steps-container">
                    <header className="graphics-youtube__steps-header">
                        <h2>{t(`youtube-thumbnail.develop.title`)}</h2>
                        <p>{t(`youtube-thumbnail.develop.subtitle`)}</p>
                    </header>

                    <div className="graphics-youtube__steps-grid">
                        {steps.map((step, index) => {
                            const Icon = step.icon;
                            return (
                                <div className="graphics-youtube__step" key={step.id}>
                                    <div className="graphics-youtube__step-icon">
                                        <Icon size={24} />
                                    </div>
                                    <h3 className="graphics-youtube__step-title">{t(`youtube-thumbnail.develop.card.${step.id}.title`)}</h3>
                                    <p className="graphics-youtube__step-description">{t(`youtube-thumbnail.develop.card.${step.id}.subtitle`)}</p>
                                    {index < steps.length - 1 && (
                                        <div className="graphics-youtube__step-connector">
                                            <Zap size={14} />
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {/* ===== TEAM ===== */}
            {graphicsYoutube.length > 0 && (
                <div className="graphics-youtube__team">
                <div className="graphics-youtube__team-container">
                    <header className="graphics-youtube__team-header">
                        <h2>{t(`youtube-thumbnail.employees.title`)}</h2>
                        <p>{t(`youtube-thumbnail.employees.subtitle`)}</p>
                    </header>

                    <div className="graphics-youtube__team-grid">
                        {graphicsYoutube.map((dev) => (
                            <a
                                key={dev.id}
                                target="_blank"
                                href={dev.avatar}
                                rel="noopener noreferrer"
                                className="graphics-youtube__team-card"
                            >
                                <div className="graphics-youtube__team-avatar">
                                    <img src={dev.avatar} alt={dev.username} />
                                    <div className={`graphics-youtube__team-status graphics-youtube__team-status_${dev.online}`} />
                                </div>
                                <h3>{dev.username}</h3>
                                <span>Youtube Graphic</span>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
            )}

            {/* ===== PORTFOLIO ===== */}
            {ourThumbnail.length > 0 && (
                <div className="graphics-youtube__portfolio" id="portfolio">
                <div className="graphics-youtube__portfolio-container">
                    <header className="graphics-youtube__portfolio-header">
                        <h2>{t(`youtube-thumbnail.works.title`)}</h2>
                        <p>{t(`youtube-thumbnail.works.subtitle`)}</p>
                    </header>

                    <div className="graphics-youtube__portfolio-grid">
                        {ourThumbnail.length > 0 && (
                                <div className="graphics-drawings__gallery__container">
                                    <div className="gallery">
                                        {ourThumbnail.slice(0, maxPhoto).map((photos) => (
                                            <Card
                                                item={photos}
                                            />
                                        ))}
                                        {ourThumbnail.length > maxPhoto && (
                                            <div onClick={() => setMaxPhoto(ourThumbnail.length)} className="card gallery-more-card">
                                                <div className="gallery-more-card__content">
                                                    <p>{t("works.graphic.other")}</p>
                                                    <h1>+{ourThumbnail.length - maxPhoto}</h1>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                    </div>
                </div>
            </div>
            )}
        </section>
    );
}